import AIEduInputTextFixedLabel from "../Input/AIEduInputTextFixedLabel";
import styles from "./Search.module.css";

const AIEduSearch = ({
    value,
    setValue,
    placeholder,
    className,
    searchHandler,
    handleInputKeyDown,
}) => {
    return (
        <div className={className}>
            <AIEduInputTextFixedLabel
                className={styles.patentPortal_Search}
                type="text"
                value={value}
                placeholder={placeholder}
                onKeyDown={handleInputKeyDown}
                onChange={(e) => setValue(e.target.value)}
            />
            <i
                className={`pi pi-search ${styles.search_icon}`}
                onClick={searchHandler}
            />
        </div>
    );
};

export default AIEduSearch;
